import React, { useEffect, useRef, useState } from 'react'
import './teams-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import TeamForm from './teams-form.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import TeamView from './team-view.component';
import TeamsList from './teams-list.component';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';

const TeamsLandingPage = ({
  gameData,
  gameElements,
  teamMembers,
  playerList,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [ teamList, setTeamList ] = useState({});
  const [ isManager, setIsManager ] = useState(false);
  const teamsRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  let teamsListener;

  useEffect(() => {
    return () => {
      if (teamsListener) teamsListener();
    }
  }, [])

  useEffect(() => {
      if (!role) return;
      if (role === 'owner' || role === 'manager') {
        setIsManager(true);
      } else {
        setIsManager(false);
      }
    }, [role])

  useEffect(() => {
    if (!gameData) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
        pageTitleEl.innerText = 'Manage Teams';
    }
    getTeamsFromDb();
  }, [gameData])
  
  useEffect(() => {
    if (!membership) return;
    checkMembership();
  }, [membership])

  function checkMembership() {
    const element = 'teams'
    const res = testMemberRestrictions({ 
      'gameData': gameData, 
      'membership': membership, 
      'element': element 
    })
    // console.log(res);

    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access Teams.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function getTeamsFromDb() {
    if (location.pathname.includes('/preview/manager')) {
      const previewTeams = Object.values(completePlayerData).filter(player => player.team);
      const teamsObj = {};
      previewTeams.forEach(player => {
        if (player.team) {
          teamsObj[player.playerId] = player
        }
      });
      setTeamList(teamsObj);
      return;
    }
    getQueryFromFirestore({
      'path': `games/${gameData.gameId}/players`,
      'queryArray': [
        {
          'field': 'team',
          'operator': '==',
          'value': true
        },
      ],
      'callback': callback,
      'handleListener': handleListener
    })
    function callback (data) {
      if (data.status !== 'active') {
        if (data && teamsRef.current[data.playerId])
          delete teamsRef.current[data.playerId];
      } else {
        teamsRef.current = {
          ...teamsRef.current,
          ...{[data.playerId]: data}
        }
      }
      setTeamList({...teamsRef.current})
    }
    function handleListener(listener) {
      teamsListener = listener;
    }
  }

  return (
    <div className='teams-landing'>
      <div className='g-card teams-card'>
        <BackButton cancel={() => navigate(
          location.pathname === `/manage/${gameData.path}/teams`
          ? `/manage/${gameData.path}`
          : -1
        )} />
        <div className='g-space-1'></div>
        <div className='card-title'>
          <ImageContainer 
            src='/images/icons/groups.png' 
            className='head-icon' />
          Create and Edit Teams</div>
        <hr />
        <div className='teams-landing-content'>
          <Routes>
            <Route path='' element={
              <TeamsList 
                playerList={playerList} 
                teamList={teamList}
                isManager={isManager} />
            }></Route>
            <Route path='create' element={
              <TeamForm 
                gameData={gameData} 
                gameElements={gameElements} 
                playerList={playerList}
                teamList={teamList}
                isManager={isManager} />
            }></Route>
            <Route path=':teamPath' element={
              <TeamView 
                gameData={gameData}
                playerList={playerList}
                teamMembers={teamMembers}
                teamList={teamList}
                isManager={isManager}
              />
            }></Route>
            <Route path=':teamPath/edit' element={
              <TeamForm 
                gameData={gameData} 
                gameElements={gameElements} 
                playerList={playerList} 
                teamList={teamList}
                isManager={isManager} />
            }></Route>
            <Route path="*" element={
              <Navigate replace to="/404" />
            } />
          </Routes>
        </div>
      </div>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default TeamsLandingPage